import { AfterViewInit, Component, ElementRef, ViewChild } from "@angular/core";

import * as Three from "three";
import * as PIXI from "pixi.js";
import { DebrisService } from "../../ambients/debris-service";
import { EventsWebsocketService } from "../../../services/entities/events-websocket.service";
import { EventSenderService } from "../event-sender.service";
import { ThreeService } from "../../rendering/threejs/three.service";
import { MapInputService } from "../../inputs/input-middlewares/map-input.middleware";
import { ThreeInputService } from "../../inputs/input-middlewares/three-input.middleware";
import { InputService } from "../../inputs/services/input.service";
import { SurfaceService } from "../../surface/surface.service";
import { CanvasState } from "../../surface/canvas/canvass.state";
import {CanvasService} from "../../surface/canvas/canvas.service";

@Component({
  selector: "binsta-canvas-debugger",
  standalone: true,
  imports: [],
  templateUrl: "./canvas-debugger.component.html",
  styleUrl: "./canvas-debugger.component.scss",
})
export class CanvasDebuggerComponent implements AfterViewInit {
  constructor(
    private three: ThreeService,
    private threeInputService: ThreeInputService,
    private inputService: InputService,
    private mapInputService: MapInputService,
    private canvasService: CanvasService,
    private surfaceService: SurfaceService,
    private debrisService: DebrisService,
    private eventSenderService: EventSenderService,
    private websocketService: EventsWebsocketService,
  ) { }

  @ViewChild("canvas")
  private canvasRef: ElementRef;

  public rotationSpeedX = 0.005;
  public rotationSpeedY = 0.005;
  animationValue = 0;

  debug = false;

  private get canvas(): HTMLCanvasElement {
    return this.canvasRef.nativeElement;
  }

  async ngAfterViewInit(): Promise<void> {
    this.canvasService.setDocument(document);
    await this.canvasService.setupCanvas(2500, 2500);
    this.surfaceService.setup(2500, 2500);
    this.inputService.makeHtmlElementTouchable(this.canvas);
    // this.three.createScene(window, 0x000000)
    this.three.createScene(this.canvas, window, 0x10100e, true);
    // this.three.createScene(this.canvas, window, 0xffffff, this.debug);
    // await this.debrisService.setup(10);
    this.three.onRender(async (timeDelta) => {
      if (this.surfaceService) {
        await this.surfaceService.render(timeDelta);
      }
      if (this.canvasService) {
        await this.canvasService.render();
      }
      // if (this.debrisService) {
      //   await this.debrisService.update(timeDelta);
      // }
    });
    await this.inputService.addInputMiddleware("three", this.threeInputService);
    await this.inputService.addInputMiddleware("map", this.mapInputService);
    this.three.startRenderLoop();
    const canvass = CanvasState.canvass.values();
    for (let canv of canvass) {
      canv.classList.add("canvas")
      document.body.appendChild(canv);
    }
  }
}
